module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ir-b1bd55f356d411f1658decff14c4e8db.jpg";